export enum ForgotPasswordMethod {
  EMAIL = 0,
  SMS = 1,
}

export interface IOTPTimerState {
  expiresAt: number | null;
  resendCooldownUntil: number | null;
}

export interface IOTPLockState {
  isResendLocked: boolean;
  resendLockUntil: number | null;
  isVerifyLocked: boolean;
  verifyLockUntil: number | null;
}

export interface IOTPCounterState {
  resendCount: number;
  maxResendCount: number;

  verifyAttempts: number;
  maxVerifyAttempts: number;
}

export interface IOTPState extends IOTPTimerState, IOTPLockState, IOTPCounterState {
  value: string;
  token: string;
  isBlock?: boolean;
  countdownTimeInSecond?: number;
}

export interface IPasswordValidation {
  minLength: boolean;
  hasNumber: boolean;
  hasLowerCase: boolean;
  hasUpperCase: boolean;
  hasSpecialChar: boolean;
  isMatch: boolean;
}

export interface IVerifyEmailParams {
  username: string;
  email: string;
}

export interface IVerifySMSParams {
  phoneNumber: string;
}

export type VerifyParams = IVerifyEmailParams | IVerifySMSParams;

export interface IOTPTimerProps {
  otpExpiry: number;
  resendCooldown: number;
  verifyLock: number;
  resendLock: number;
}

export interface IOTPCounterProps {
  verifyAttempts: number;
  remainingVerifyAttempts: number;
  currentResendCount: number;
  maxResendCount: number;
}

export interface IOTPLockProps {
  isVerifyLocked: boolean;
  isResendLocked: boolean;
}

export interface IVerifyEmailRequest {
  appCode: string;
  email: string;
  username: string;
}

export interface IVerifySMSRequest {
  appCode: string;
  phoneNumber: string;
}

export interface IResetPasswordRequest {
  username: string;
  appCode: string;
  newPassword: string;
  otpToken: string;
}

export interface IVerifyInfoData {
  isValid?: boolean;
  isSendOtp?: boolean;

  lastTimeGetOTP: string;
  lockGetOtpInSecond: number;
  lockMaxGetOTPInSecond: number;
  maxCounter: number;
  currentCounter: number;

  isBlock: boolean;
  lockVerifyInSecond: number;

  currentTime: string;
  countdownTimeInSecond: number;
  otpExpireIn: number;

  code: string;
  message: string;
}

export interface IParsedOTPData {
  expiresAt: number;
  resendCooldownUntil: number;

  isResendLocked: boolean;
  resendLockUntil: number | null;
  isVerifyLocked: boolean;
  verifyLockUntil: number | null;

  resendCount: number;
  maxResendCount: number;
  verifyAttempts: number;
  maxVerifyAttempts: number;
  countdownTimeInSecond: number;
  isBlock: boolean;
}

export interface IResendOTPRequest {
  appCode: string;
  username: string;
  destAddress: string;
  type: number;
  language: string;
}

export interface IVerifyOTPRequest {
  appCode: string;
  username: string;
  destAddress: string;
  type: number;
  otp: string;
}

export interface IVerifyOTPFailureData {
  currentCounter?: number;
  maxCounter?: number;
  lockVerifyInSecond?: number;
  isBlock?: boolean;
  countdownTimeInSecond?: number;
  code?: string;
  message?: string;
}

export interface IResendOTPSuccessData extends IVerifyInfoData {
  currentCounter: number;
  maxCounter: number;
  isBlock: boolean;
  otpExpireIn: number;
  lockGetOtpInSecond: number;
  countdownTimeInSecond: number;
}

export interface IApiResponse<T = unknown> {
  code?: string;
  message?: string;
  data?: T;
}
